exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.kui-hello[data-v-288c5bbe]{\r\n  font-size: 30px;\r\n  color: #333;\n}\r\n", "", {"version":3,"sources":["C:/code/kui-plus/packages/hello/packages/hello/Hello.vue"],"names":[],"mappings":";AAuBA;EACA,gBAAA;EACA,YAAA;CACA","file":"Hello.vue","sourcesContent":["<template>\r\n  <div class=\"kui-hello\">\r\n    {{ msg }}\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'kyHello',\r\n  props:{\r\n    msg:{\r\n      type: String\r\n    }\r\n  },\r\n  data(){\r\n    return {\r\n      // msg: 'Hello kui!'\r\n    }\r\n  }\r\n}\r\n</script>\r\n\r\n<style scoped>\r\n.kui-hello{\r\n  font-size: 30px;\r\n  color: #333;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-288c5bbe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./packages/hello/Hello.vue
// module id = UCOU
// module chunks = 0